<template>
  <Teleport to="body">
    <TransitionRoot as="template" :show="props.open">
      <div class="fixed inset-0 z-[200]">
        <!-- Backdrop -->
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <div
            class="absolute inset-0 bg-[rgba(20,17,11,0.8)] backdrop-blur-[2px]"
            @click="handleCancel"
          />
        </TransitionChild>

        <!-- Modal wrapper -->
        <div class="absolute inset-0 flex items-end text-center lg:items-center lg:justify-center">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              class="relative pointer-events-auto flex w-full h-60 transform flex-col overflow-hidden rounded-lg bg-neutral-gray-1 text-left shadow-xl transition-all lg:w-120"
              @click.stop
              @touchend.stop
            >
              <!-- Header -->
              <div
                class="flex w-full items-center justify-between border-b border-outline-dividers bg-bg-canvas p-4"
              >
                <div>
                  <div class="flex items-center">
                    <Icon name="TriangleAlert" class="mr-1 h-4 w-4 stroke-error" />
                    <div class="font-inter text-sm font-semibold text-error">Unsaved Changes</div>
                  </div>
                  <div
                    class="font-league text-[1.75rem] font-semibold tracking-[-.56px] text-strongest"
                  >
                    Discard Changes
                  </div>
                </div>

                <Button @click="handleCancel" variant="paper-primary" size="sm">
                  <template #icon>
                    <Icon name="X" class="h-4 w-4 text-cta-tertiary-outline-icon" />
                  </template>
                </Button>
              </div>

              <!-- Body -->
              <div class="grow overflow-auto bg-bg-canvas">
                <div
                  class="p-6 text-center text-xl font-league text-strongest font-medium tracking-[-0.4px]"
                >
                  If you discard your changes, they will not be saved.
                </div>
              </div>

              <!-- Footer -->
              <div
                class="relative w-full border-t border-outline-dividers bg-bg-canvas px-6 py-value-2"
              >
                <div class="flex justify-end gap-2">
                  <Button @click="handleCancel" variant="paper-primary" size="sm">
                    <template #label>Cancel</template>
                  </Button>

                  <Button @click="handleConfirm" variant="primary-grey" size="sm">
                    <template #icon>
                      <Icon name="Trash2" class="h-4 w-4 stroke-error" />
                    </template>
                    <template #label>Discard Changes</template>
                  </Button>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </TransitionRoot>
  </Teleport>
</template>

<script setup>
import { watch } from "vue";
import { Teleport } from "vue";
import { TransitionChild, TransitionRoot } from "@headlessui/vue";
import { Icon, Button } from "@/components";

const emit = defineEmits(["close-modal", "confirm"]);

const props = defineProps({
  open: { type: Boolean, required: true },
  modal_config: { type: Object, required: true },
});

watch(
  () => props.open,
  (isOpen) => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }
);

function handleConfirm() {
  emit("confirm");
  emit("close-modal");
}

function handleCancel() {
  emit("close-modal");
}
</script>
